import React, { useContext } from 'react'
import { LinkOverlay as ChakraLinkOverlay } from '@chakra-ui/react'
import {
  As,
  HubStyleObject,
  forwardRef,
  HubLinkContext,
} from '@hub/design-system-base'

interface LinkOverlayProps {
  as?: As
  sx?: HubStyleObject
  href: string
  isExternal?: boolean
}

// TODO: Make work with Next links, external links, and internal non-Next links
export const LinkOverlay = forwardRef<
  LinkOverlayProps,
  typeof ChakraLinkOverlay
>(({ children, href, isExternal, as, sx }, ref) => {
  const Link = useContext(HubLinkContext)
  return (
    <ChakraLinkOverlay
      ref={ref}
      href={href}
      as={as || (Link && (props => <Link to={props.href} {...props} />))}
      sx={sx}
      isExternal={isExternal}
    >
      {children ?? href}
    </ChakraLinkOverlay>
  )
})
